// extracted by mini-css-extract-plugin
module.exports = {"ctoButton":"CellularCapability_ctoButton__2s_cz","noHoverBg":"CellularCapability_noHoverBg__2ZXjp"};